<div id="teacher-wallet-index" class="container margin-top-1">

  <mat-card class="custom-dashboard-mat-card margin-top-2 margin-auto">
    <h1 class="primary bold"><i class="fas fa-business-time"></i> {{ "your-hours-wallet" | translate }}</h1>
    <div class="row pt-4">


      <table width="100%" class="table table-striped">
        <thead>          
          <tr>
            <th class="p-2" colspan="2">{{ "teacher" | translate }}</th>            
            <th class="p-2 text-center">{{ "hours" | translate }}</th>
            <th class="p-2"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let hour of dataSource">
            <td class="p-2" *ngIf="!hour.photo_url"><img class="wallet-image" src="assets/img/free-tag.png"></td>
            <td class="p-2" *ngIf="hour.photo_url"> <img [src]="hour.photo_url" class="wallet-image"> </td>

            <td class="pt-3" *ngIf="hour.teacher_id != 'free'">{{ hour.teacher_name }} 
 
            </td>
            
            <td class="pt-3" *ngIf="hour.teacher_id == 'free'"> {{ "free-hours-any-teacher" | translate }}</td>

            <td class="pt-3 text-center"><strong> {{ hour.quantity }} </strong></td>

             <td class="p-2 text-right" *ngIf="hour.teacher_id != 'free'">
                <!-- <a [routerLink]="['/search/teacher', hour.teacher_id, hours.classes.lesson_id]" class="btn btn-secondary">+ datos</a> -->
                <table class="lesson-table">
                  <tr *ngFor="let lesson of hour.classes">
                    <td class="text-right">
                    {{ lesson.lesson_name }} - {{ lesson.quantity }} h. 
                    <a (click)="navigateTeacher(hour.teacher_id, lesson.lesson_id, lesson.lesson_name)" class="reservation-link">{{ "booking" | translate }}</a>
                  </td>
                  </tr>
                </table>
             </td> 
            <td class="p-2 text-right" *ngIf="hour.teacher_id == 'free'"><a href="#" [routerLink]="['/search/teacher']" class="btn btn-primary">{{ "search-teacher" | translate }}</a></td>
            
          </tr>
        </tbody>      
      </table>

    </div>
  </mat-card>

  <mat-card class="mat-card margin-top-2 margin-auto text-center">

    <div class="margin-bottom-1" *ngIf="walletLength.teacher_id=='free'">
      <div class="mat-h3 font-weight-bold">
        {{"meet-our-teachers" | translate }}
      </div>
      <button mat-raised-button color="primary" [routerLink]="['/search/teacher']">{{"book-your-trial-class" |
        translate}}</button>
    </div>

    <div *ngIf="walletLength.teacher_id=='free'">
      <mat-divider [inset]="true"></mat-divider>
      <div class="mat-caption margin-top-1">
       <span class="free-classes-message"><i class="fas fa-info-circle"></i> {{"you-have-trial-classes" | translate}}</span>
      </div>
      <div class="margin-top-1">
        <div class="mat-caption">
          {{"search-your-teacher" | translate }}
        </div>
        <div class="mat-caption">
          {{"ideal-teacher-for-you" | translate}}
        </div>
      </div>
    </div>

    <div  class="teacher-options">
      <div class="margin-bottom-1 margin-top-2">
        <div class="mat-h3 font-weight-bold">
          {{"keep-learning" | translate}}
        </div>
      </div>
      <button mat-raised-button color="primary" [routerLink]="['/search/teacher']">{{ "search-teacher" | translate }}</button>
      <div class="payment-logos margin-top-2">
        <img class="margin-right-1" src="../../../../../assets/img/paypal.png" alt="">
        <img src="../../../../../assets/img/redsys.png" alt="">
      </div>
    </div>
  </mat-card>
</div>

<app-loading [loading]="loading || loading2"></app-loading>